import { TOGGLE_PLUS_UPGRADE_MODAL } from "./types";

export const togglePlusUpgradeModal = (state) => (dispatch) => {
  dispatch({
    type: TOGGLE_PLUS_UPGRADE_MODAL,
    payload: state,
  });
};
